import React, { FC, ReactNode } from 'react'
import { Box, Stack, Typography } from '@mui/material'

import { Layout } from '@/apps/latest/components/templates/Layout'
import { PORTAL_TEXT } from '@/apps/latest/shared/styles/portalTypography'

// Notion 流 portal page の最外 wrap. Layout (= main shell. sidebar + topbar + 720 content) を
// そのまま再利用し、 title row + 縦 section stack を描く.
// docs/design-system/03 §2 + 5 原則 #1 (= 白い紙).
// design/16 §3.5 / §4.6 — main / portal で 720 + outer padding 統一.
//
// title 横に icon は出さない (= 冗長). breadcrumb の 「設定 / <title>」 で文脈は十分.
interface PageScaffoldProps {
  title: string
  /** title 横の inline caption (= 「全 N 件」 等). 任意. design/18 §2.3 R6. */
  meta?: ReactNode
  /** title 右の actions (= 「+ 新規」 ボタン等). 任意. */
  actions?: ReactNode
  /** 表・チャートが主役で 720px に収まらないページだけ true (Layout の wide をそのまま委譲). */
  wide?: boolean
  children: ReactNode
}

export const PageScaffold: FC<PageScaffoldProps> = ({
  title,
  meta,
  actions,
  wide,
  children,
}) => (
  <Layout breadcrumb={['設定', title]} wide={wide}>
    <Stack
      direction="row"
      alignItems="baseline"
      justifyContent="space-between"
      sx={{ mb: 4 }}
      gap={2}
    >
      <Stack direction="row" alignItems="baseline" gap={1.5}>
        <Typography
          sx={{
            fontSize: 20,
            fontWeight: 600,
            color: 'text.primary',
            letterSpacing: 0.2,
          }}
        >
          {title}
        </Typography>
        {meta && <Typography sx={PORTAL_TEXT.caption}>{meta}</Typography>}
      </Stack>
      {actions && <Box>{actions}</Box>}
    </Stack>
    <Stack gap={3}>{children}</Stack>
  </Layout>
)
